import { render } from "./PlansPublic.vue?vue&type=template&id=db8468a8&scoped=true"
import script from "./PlansPublic.vue?vue&type=script&lang=js"
export * from "./PlansPublic.vue?vue&type=script&lang=js"

import "./PlansPublic.vue?vue&type=style&index=0&id=db8468a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8468a8"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerOval from 'quasar/src/components/spinner/QSpinnerOval.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QIcon,QDialog,QCard,QBtn,QCardSection,QInput,QSpinnerOval,QCardActions});
